module.exports = __webpack_public_path__ + "img/01.d21f60e3.png";